var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeartCrack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M480.99 255.776L268.749 474.562C261.75 481.813 250.25 481.813 243.126 474.562L31.01 255.901C-12.488 202.767 -10.363 123.504 38.26 73.621L40.76 71.245C83.734 27.215 149.38 20.807 199.907 50.343L239.948 143.792L144.005 207.768L144.122 207.885L144.017 207.955L287.999 351.791L240.059 223.927L336.008 159.947L335.959 159.783L335.996 159.76L335.526 158.338L304.461 54.77C355.759 19.877 426.016 24.902 471.24 71.12L473.74 73.621C522.363 123.504 524.488 202.767 480.99 255.776Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartCrack);
export default __webpack_public_path__ + "static/media/heart-crack.e0af7dc964de3f9a26e5c2cfff19591b.svg";
export { ForwardRef as ReactComponent };